import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/base/ScrollReveal';
import CountUp from '@/components/base/CountUp';

const partners = [
  { icon: 'ri-government-line', label: '政府文旅单位', desc: '文化数字化建设 · 县域IP打造' },
  { icon: 'ri-building-line', label: '品牌企业', desc: '品牌文化赋能 · 流量电商运营' },
  { icon: 'ri-team-line', label: '渠道合伙人', desc: '城市合伙人 · 区域代理合作' },
  { icon: 'ri-graduation-cap-line', label: '院校机构', desc: '产教融合 · 人才共育 · 项目孵化' },
];

export default function PartnershipCTA() {
  return (
    <section className="relative w-full bg-background-950 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background-950 via-background-950/95 to-background-950"></div>

      {/* Section divider with glow */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary-500/20 to-transparent"></div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-[2px] bg-gradient-to-r from-transparent via-primary-500/40 to-transparent blur-sm"></div>

      <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
        <div className="max-w-screen-2xl mx-auto">
          <ScrollReveal>
            <div className="text-center mb-16">
              <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-primary-500 mb-6">
                深耕文化数字，赋能产业升级
              </h2>
              <p className="text-secondary-400 text-lg max-w-2xl mx-auto leading-relaxed">
                诚邀政府文旅单位、品牌企业、渠道合伙人、院校机构、县域创业者携手合作，共拓文化数字化新蓝海。
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-16">
            {partners.map((item) => (
              <ScrollReveal key={item.label}>
                <div className="partner-card group bg-background-800/40 rounded-2xl border border-primary-500/10 p-6 md:p-8 text-center transition-all duration-500 hover:-translate-y-2">
                  {/* Inner glow on hover */}
                  <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                    style={{
                      background: 'radial-gradient(circle at center, rgba(200,160,80,0.06) 0%, transparent 60%)',
                    }}
                  ></div>

                  <div className="relative z-10">
                    <div className="w-14 h-14 mx-auto rounded-xl bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/20 group-hover:scale-110 transition-all duration-300">
                      <i className={`${item.icon} text-primary-500 text-2xl`}></i>
                    </div>
                    <h4 className="text-foreground-50 font-semibold text-sm mb-2 group-hover:text-primary-500 transition-colors duration-300 whitespace-nowrap">{item.label}</h4>
                    <p className="text-secondary-500 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/cooperation"
                className="group px-8 py-3.5 bg-accent-500 text-foreground-50 font-medium rounded-full text-sm transition-all duration-300 flex items-center gap-2 whitespace-nowrap cursor-pointer hover:bg-accent-400 hover:shadow-[0_0_40px_rgba(180,60,40,0.25)]"
              >
                立即合作咨询
                <span className="w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
              <Link
                to="/contact"
                className="px-8 py-3.5 border border-primary-500/50 text-primary-500 font-medium rounded-full text-sm hover:bg-primary-500/10 hover:border-primary-500/70 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                联系我们
              </Link>
            </div>
          </ScrollReveal>

          <ScrollReveal>
            <div className="mt-20 flex items-center justify-center gap-8 md:gap-16 flex-wrap">
              <div className="text-center group">
                <div className="font-heading text-3xl md:text-5xl font-bold text-primary-500 group-hover:scale-110 transition-transform duration-300">
                  <CountUp end={117} duration={2200} />
                </div>
                <p className="text-secondary-500 text-xs mt-1">覆盖县域</p>
              </div>
              <div className="w-px h-10 bg-primary-500/15"></div>
              <div className="text-center group">
                <div className="font-heading text-3xl md:text-5xl font-bold text-primary-500 group-hover:scale-110 transition-transform duration-300">
                  <CountUp end={100} duration={2000} suffix="+" />
                </div>
                <p className="text-secondary-500 text-xs mt-1">精品AI漫剧</p>
              </div>
              <div className="w-px h-10 bg-primary-500/15"></div>
              <div className="text-center group">
                <div className="font-heading text-3xl md:text-5xl font-bold text-primary-500 group-hover:scale-110 transition-transform duration-300">
                  <CountUp end={1000} duration={2500} suffix="+" />
                </div>
                <p className="text-secondary-500 text-xs mt-1">月产量级/集</p>
              </div>
              <div className="w-px h-10 bg-primary-500/15"></div>
              <div className="text-center group">
                <div className="font-heading text-3xl md:text-5xl font-bold text-primary-500 group-hover:scale-110 transition-transform duration-300">
                  <CountUp end={4} duration={1500} />
                </div>
                <p className="text-secondary-500 text-xs mt-1">核心业务板块</p>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}
